import { Controller } from "@hotwired/stimulus";

// Drives <dialog> elements loaded into <turbo-frame id="modal"> via GET.
// Calls showModal() on connect; clears the frame when the dialog closes
// without navigating (cancel / backdrop click).
export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    this.dialogTarget.showModal();
    this.dialogTarget.addEventListener("close", this._onClose, { once: true });
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this._onClose);
  }

  // Private

  _onClose = () => {
    const frame = document.getElementById("modal");
    if (frame) frame.innerHTML = "";
  };
}
